import { themeVariables } from "Components/theme";
import { WebGL2Effect, WebGL2IconNodeStyle } from "yfiles";
export default async (dataURL, width, height, padding, shape) => new Promise(resolve => {
    const image = new Image();
    image.onload = function () {
        const canvas = document.createElement("canvas");
        canvas.width = width !== null && width !== void 0 ? width : image.naturalWidth;
        canvas.height = height !== null && height !== void 0 ? height : image.naturalHeight;
        const ctx = canvas.getContext("2d", { willReadFrequently: true });
        ctx.drawImage(image, 0, 0, image.naturalWidth, image.naturalHeight, padding, padding, canvas.width - padding * 2, canvas.height - padding * 2);
        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        resolve(new WebGL2IconNodeStyle({
            icon: imageData,
            shape,
            fill: "#ffffff",
            stroke: themeVariables["gray-500"],
            effect: WebGL2Effect.NONE,
            preserveAspectRatio: true
        }));
    };
    image.onabort = function () {
        resolve(undefined);
    };
    image.onerror = function () {
        resolve(undefined);
    };
    image.src = dataURL;
});
